export function prettyLabel(value) {
  if (typeof value !== "string") return value;
  let fixed = value.replace(/_|-/g, " ");
  return fixed[0].toUpperCase() + fixed.slice(1);
}

export function getFirstLetter(value) {
    if (typeof value !== "string") return value;
    return value.slice(0,1).toUpperCase()
  }

export function findJob(jobs, commitSha) {
  // eslint-disable-next-line eqeqeq
  return jobs.find((job) => (job.commit.id == commitSha && job.name === "Theme Publish"));
}

const branches = [
  {
    name: 'Develop',
    branch: 'develop',
    siteUrlTag: 'dev',
  },
  {
    name: 'QA',
    branch: 'qa-automation',
    siteUrlTag: 'qa',
  },
  {
    name: 'Prelive',
    branch: 'prelive',
    siteUrlTag: 'prelive',
  },
  {
    name: 'Live',
    branch: 'master',
    siteUrlTag: '',
  }
];

export function getBranches({ excludeBranches = [], includeBranches = [] } = {}) {
  let result = branches.filter(b => !excludeBranches.includes(b.branch));

  includeBranches.forEach(newBranch => {
    const { after } = newBranch;

    if (after) {
      const index = result.findIndex(b => b.branch === after);
      if (index !== -1) {
        result = [
          ...result.slice(0, index + 1),
          newBranch,
          ...result.slice(index + 1)
        ];
      } else {
        result = [newBranch, ...result];
      }
    } else {
      result = [...result, newBranch];
    }
  });

  return result;
}
